export const ADALO_TOKEN_REG_EX = /^.{8}-.{4}-.{4}-.{4}-.{12}$/;
